import React from 'react';
import WizardContainer from '../../components/Wizard/WizardContainer';
import { ApplicationStatus } from '../../types/wizard';
import { usePageTracking, useWizardStepTracking } from '../../hooks/useAnalytics';

interface DocumentReviewProps {
  applicationStatus: ApplicationStatus;
}

const DocumentReview: React.FC<DocumentReviewProps> = ({ applicationStatus }) => {
  usePageTracking('Document Review');
  useWizardStepTracking('document-review', 5, 7);

  return (
    <WizardContainer
      currentStepId="document-review"
      applicationStatus={applicationStatus}
    >
      <div className="max-w-2xl mx-auto">
        <div className="card p-8 text-center">
          <div className="text-6xl mb-6">📋</div>

          <h1 className="text-3xl font-bold text-charcoal mb-4">
            Documents Under Review
          </h1>

          <p className="text-lg text-gray-600 mb-6">
            Thank you for submitting your documents! Our team is currently reviewing them.
          </p>

          <div className="rounded-xl border border-logo-green bg-logo-green/10 p-6 mb-6">
            <div className="flex items-start gap-3 text-left">
              <div className="text-2xl mt-1">⏱️</div>
              <div>
                <p className="font-semibold text-charcoal mb-2">
                  What happens next?
                </p>
                <ul className="text-sm text-gray-600 space-y-2">
                  <li>• Our team will verify your application and documents</li>
                  <li>• If approved, your courier account will be created and we'll send the next steps</li>
                  <li>• If we need any clarification, we'll reach out via email</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="soft-panel p-4">
            <p className="text-sm text-gray-600">
              We'll contact you when the review is complete. You can also check back here using SMS verification.
            </p>
          </div>
        </div>
      </div>
    </WizardContainer>
  );
};

export default DocumentReview;
